export default "__VITE_ASSET__4c1be601__"